module.exports = __webpack_public_path__ + "img/two-section-right.6b478c67.png";